export const frTranslations = {
  loading: {
    message: 'Restez connecté pour voir en direct les dernières informations de la prise en charge'
  },
  not_found: {
    message: "Désolé, nous n'avons pas connaissance de ce véhicule."
  },
  beneficiary_location: {
    found: {
      message: "Vous avez été géolocalisé à l'adresse suivante :",
      address_inline: "{number} {street_name}, {city_zip} {city_name}, {country}"
    },
    sent: {
      title: 'Votre position a été envoyée',
      subtitle: 'Votre dépanneur ne va pas tarder'
    },
    modify_btn_content: 'Modifier',
    confirm_btn_content: "Oui c'est la bonne adresse",
    button_loading_content: 'Calcul de la position GPS en cours',
    accuracy_estimate: 'Précision estimée : ~{accuracy} m',
    ask: {
      underground_question: 'Le véhicule se trouve t-il dans une zone à hauteur limitée ?',
      underground_yes: "Oui",
      underground_no: 'Non',
      manual_fallback_info: "Impossible d'obtenir votre position GPS. Merci de saisir votre adresse manuellement."
    }
  },
  manual_geolocation: {
    address_input_placeholder: "Insérer l'adresse ici...",
    save_btn_content: 'Enregistrer',
    cancel_btn_content: 'Annuler',
    title: 'Entrez votre géolocalisation exacte:'
  },
  share_position: {
    geolocation_refused: {
      ios_device: "Vous n'autorisez pas la géolocalisation. <a target='_blank' href='https://zupple.fr/go/faq/activer-la-geolocalisation-sous-ios/'>Voici une documentation pour permettre la géolocalisation sur votre appareil.</a>",
      android_device: "Vous n'autorisez pas la géolocalisation. <a target='_blank' href='https://support.google.com/chrome/answer/142065?hl=fr&co=GENIE.Platform%3DAndroid'>Voici une documentation pour permettre la géolocalisation sur votre appareil.</a>",
      no_mobile_device: "Vous n'autorisez pas la géolocalisation. Veuillez l'accepter pour permettre à votre dépanneur de vous localiser"
    },
    geolocation_not_available: "Erreur : impossible d'obtenir la position.",
    geolocation_too_long: "Erreur : la récupération de la position a pris trop de temps"
  },
  message_composer: {
    placeholder: "Entrez votre message",
    submit: 'Envoyer'
  },
  truck_en_route: {
    tow_truck_image: {
      alt: 'Camion de dépannage'
    },
    message_with_truck_image: "Bonne nouvelle ! {first_name}, l’un de nos meilleurs dépanneurs, est en route pour vous aider. À son arrivée, merci de bien vérifier son identité à l’aide de son immatriculation et de la photo du camion fournie.",
    message_without_truck_image: "Bonne nouvelle ! {first_name}, l’un de nos meilleurs dépanneurs, est en route pour vous aider. À son arrivée, merci de bien vérifier son identité à l’aide de son immatriculation."
  },
  guided_depollution: {
    vehicle_photo_alt: "Véhicule d'intervention"
  },
  missions_infos: {
    driver_name: {
      title: 'Votre dépanneur'
    },
    company_name: {
      title: 'Votre société de dépannage'
    }
  },
  notifications: {
    modal_title: 'Restez informé',
    prompt: 'Activez les notifications pour être prévenu dès que votre dépanneur vous envoie un message.',
    enable_button: 'Activer les notifications',
    decline_button: 'Plus tard'
  }
}